import { render, staticRenderFns } from "./taskToReject.vue?vue&type=template&id=38541042&scoped=true&"
import script from "./taskToReject.vue?vue&type=script&lang=js&"
export * from "./taskToReject.vue?vue&type=script&lang=js&"
import style0 from "./taskToReject.vue?vue&type=style&index=0&id=38541042&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38541042",
  null
  
)

export default component.exports